import Vue from "vue";
import VueRouter from "vue-router";
import M from "@/libs/mapping.js";
import { CAFE24_ROUTES } from "./cafe24.js";
import SetStoreInfo from "@/libs/membership/setting-store-info.js";

Vue.use(VueRouter);

let path = M.urlPath();

//routes 배열 담을 변수
let routeArray = [];

/**
 * 경로에 따른 routes
 */
routeArray = CAFE24_ROUTES;

const routes = routeArray;
const router = new VueRouter({
  mode: "history",
  routes,
});

/**
 * store 정보 세팅
 */
new SetStoreInfo(router, path);

export default router;
